
export enum Orientation {
    LANDSCAPE = "landscape",
    PORTRAIT = "portrait"
}
